import React from "react";

export const ChatDropDown = (props) => {
    let optionItems = {};

    switch(props.currentUserData.userType) {
        case 1:
			if ( props && props.sessionUsers )
				{
					 optionItems = props.sessionUsers.map((user, key) => 
							(user.userType == 2 && user.isOnline === true) && 
								<option value={user.email} msgtype="p2p" name={user.firstName}>{user.firstName}</option>
						);
				}       
			break;
        case 2:
			if ( props && props.sessionUsers )
				{
					 optionItems = props.sessionUsers.map((user, key) => 
                        ( user.id != props.currentUserData.id && user.isOnline === true ) && 
                            <option value={user.email} msgtype="p2p" name={user.firstName}>{user.firstName} {user.userType == 1 ? '(Instructor)' : ''}</option>
                    );
				}
            break;
    }
    

    return (
            <>
                <select className="chat-option" onChange={(e) => props.handleChangeOption(e)} onClick={props.getSessionUsers}>
                    <option value="" msgtype="channel" name="" selected>Everyone</option>
                    {optionItems}
                </select>
            </>
        ) 
}